import { useState, useEffect } from 'react';
import { TourBagStaticService } from '@/service';
import { LoftLieHelper } from '@/library';

const IRON_HEAD_TYPE_ID = 4;
const WEDGE_HEAD_TYPE_ID = 5;

export const useEditLoftLie = () => {
  const [ironLieOptions, setIronLieOptions] = useState<LoftLieHelper.ILieOptionMap>();
  const [ironLoftOptions, setIronLoftOptions] = useState<LoftLieHelper.ILoftOptionMap>();
  const [wedgeLieOptions, setWedgeLieOptions] = useState<LoftLieHelper.ILieOptionMap>();
  const [wedgeLoftOptions, setWedgeLoftOptions] = useState<LoftLieHelper.ILoftOptionMap>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getDropdownData = async () => {
      const [digitSourceTable, fractionSourceTable, lieDigitJoinTable, lieFractionJoinTable, loftDigitJoinTable, loftFractionJoinTable] = await Promise.all([
        TourBagStaticService.getDigitData(),
        TourBagStaticService.getFractionData(),
        TourBagStaticService.getLieDigitsData(),
        TourBagStaticService.getLieFractionData(),
        TourBagStaticService.getLoftDigitData(),
        TourBagStaticService.getLoftFractionData(),
      ]);

      // build iron dropdown data
      const { loftDropdownOptionMap: ironLoftDropdownOptionMap, lieDropdownOptionMap: ironLieDropdownOptionMap } = LoftLieHelper.buildDropdownData({
        headTypeId: IRON_HEAD_TYPE_ID,
        digitSourceTable,
        fractionSourceTable,
        lieDigitJoinTable,
        lieFractionJoinTable,
        loftDigitJoinTable,
        loftFractionJoinTable,
      });
      setIronLoftOptions(ironLoftDropdownOptionMap);
      setIronLieOptions(ironLieDropdownOptionMap);

      // build wedge dropdown data
      const { loftDropdownOptionMap: wedgeLoftDropdownOptionMap, lieDropdownOptionMap: wedgeLieDropdownOptionMap } = LoftLieHelper.buildDropdownData({
        headTypeId: WEDGE_HEAD_TYPE_ID,
        digitSourceTable,
        fractionSourceTable,
        lieDigitJoinTable,
        lieFractionJoinTable,
        loftDigitJoinTable,
        loftFractionJoinTable,
      });
      setWedgeLoftOptions(wedgeLoftDropdownOptionMap);
      setWedgeLieOptions(wedgeLieDropdownOptionMap);
      setLoading(false);
    };

    getDropdownData();
  }, []);

  return {
    ironLoftOptions,
    ironLieOptions,
    wedgeLoftOptions,
    wedgeLieOptions,
    loading,
  };
};
